import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgPlus = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 10V4H12V10H18V12H12V18H10V12H4V10H10Z"
      fill="currentColor"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgPlus);

export default ForwardRef;
